import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { IMAGES } from "../lib/site";

const CHAPTERS = [
  {
    title: "Il pavimento è il nostro mestiere",
    body: "Posa a correre, spine italiane e francesi, lamatura, SPC, laminati e PVC: non vendiamo pavimenti, li facciamo vivere. Tutta la nostra esperienza è concentrata su un unico mestiere, fatto a mano e con cura, dal primo listone all'ultimo battiscopa.",
  },
  {
    title: "Il sopralluogo è gratuito",
    body: "Ogni casa ha la sua storia: mobili, porte, dislivelli. Veniamo a vedere tutto di persona, senza impegno, prima di confermare il prezzo.",
  },
  {
    title: "Il prezzo lo vedi prima",
    body: "I nostri prezzi standard sono pubblici. Nessuna sorpresa, solo chiarezza da artigiani veri.",
  },
];

const Manifesto = () => (
  <section
    id="manifesto"
    className="relative bg-cream py-28 md:py-40"
    data-testid="manifesto-section"
  >
    <div className="mx-auto grid max-w-7xl gap-16 px-5 md:px-10 lg:grid-cols-[1fr_1.2fr]">
      <div className="relative">
        <Reveal className="lg:sticky lg:top-32">
          <p className="mb-4 font-sans text-xs font-light uppercase tracking-[0.45em] text-clay">
            Il manifesto
          </p>
          <h2 className="font-display text-4xl font-medium leading-tight text-ink sm:text-5xl lg:text-6xl">
            Qualità che si <em className="text-honey">calpesta</em> ogni
            giorno.
          </h2>
          <motion.div
            initial={{ clipPath: "inset(0 100% 0 0)" }}
            whileInView={{ clipPath: "inset(0 0 0 0)" }}
            viewport={{ once: true }}
            transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1], delay: 0.3 }}
            className="relative mt-10 hidden overflow-hidden rounded-2xl shadow-2xl shadow-bark/30 lg:block"
          >
            <img
              src={IMAGES.manifesto}
              alt="Dettaglio di posa parquet"
              className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-walnut/50 to-transparent" />
            <span className="absolute bottom-4 left-5 font-sans text-[10px] uppercase tracking-[0.4em] text-cream/80">
              Lamatura e verniciatura · Cantiere Tufello
            </span>
          </motion.div>
        </Reveal>
      </div>

      <div className="flex flex-col divide-y divide-bark/15">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.12} className="group py-12 first:pt-0">
            <div>
              <h3 className="font-display text-2xl font-medium text-ink transition-colors duration-300 group-hover:text-clay md:text-3xl">
                {c.title}
              </h3>
              <p className="mt-4 max-w-lg font-sans text-sm font-light leading-relaxed text-bark/80 md:text-base">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
